module.exports = __webpack_public_path__ + "img/Bahn_Schneeschleuder_2kl.51be3b35.jpg";